import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
  ViewChild,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ApiCallService } from '../../../Services/api-call-service.service';
import { ErrorhandlingService } from '../../../Services/error-handling.service';
import { ChangeDetectorRef } from '@angular/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastrService } from 'ngx-toastr';
import { GameService } from '../../../Services/game.service';
import { LoaderService } from '../../../Services/loader-service.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { UtilsService } from '../../../Services/utils.service';
import { Subject, takeUntil } from 'rxjs';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { ReferalCtaComponent } from '../../../common/referal-cta/referal-cta.component';
import { LoginComponent } from '../../login/login.component';
@Component({
  selector: 'app-casino-landing',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    CarouselModule,
    FontAwesomeModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    ReferalCtaComponent,
    LoginComponent,
  ],
  templateUrl: './casino-landing.component.html',
  styleUrl: './casino-landing.component.scss',
})
export class CasinoLandingComponent implements OnInit {
  constructor(
    private _apiCall: ApiCallService,
    private router: Router,
    private toastr: ToastrService,
    private gameService: GameService,
    private fb: FormBuilder,
    private ErroHandling: ErrorhandlingService,
    private _loaderService: LoaderService,
    private breakpointObserver: BreakpointObserver,
    private _utilsService: UtilsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  private destroy$ = new Subject<void>();
  getDeviceOS(): 'iOS' | 'Android' | 'Desktop' {
    if (typeof window === 'undefined') return 'Desktop';

    const ua = navigator.userAgent || navigator.vendor;

    if (/android/i.test(ua)) {
      return 'Android';
    }

    if (
      /iPad|iPhone|iPod/i.test(ua) ||
      (ua.includes('Mac') && navigator.maxTouchPoints > 1)
    ) {
      return 'iOS';
    }

    return 'Desktop';
  }
  async checkAndRequest() {
    const os = this.getDeviceOS();
    const permission = Notification.permission;

    if ((permission === 'denied' || permission === 'default') && os === 'iOS') {
      // Show your custom Modal here
      this._utilsService.triggerFirebaseFunction(true);
    }
  }
  ngOnInit(): void {
    this.checkAndRequest();
    // this.getTestimonials();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  croswsIcon = faXmark;
  @ViewChild('referalCta') referalCta!: ReferalCtaComponent;

  showLoginModal = false;

  /** True when a valid auth token is present (browser only). */
  get isLoggedIn(): boolean {
    return isPlatformBrowser(this.platformId) && !!localStorage.getItem('token');
  }

  triggerReferalModal() {
    // Guests must sign up first to claim the signup bonus.
    if (!this.isLoggedIn) {
      this.showLoginModal = true;
      return;
    }
    if (this.referalCta) {
      this.referalCta.openrefral();
    }
  }

  closeLoginModal() {
    this.showLoginModal = false;
  }

  AddPlayerNameModal = false;
  AddPlayerModal = false;
  captchaImages: any;
  captchaCode: any;

  allowedGames: string[] = [];
  gameAccounts: any;
  GameName: any;
  matchedGameDetails: any = null;

  testimonialsImages: any[] = [
    {
      Name: '',
      Description: 'Fly high and cash out big.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/avitr.png',
      Route: 'Avaitar',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/avitr.png',
      lookup: 'aviator',
    },
    {
      Name: '',
      Description: 'Elite card gaming at its best.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/baccaret.png',
      Route: 'Baccaret',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/baccaret.png',
      lookup: 'bacchrat',
    },
    {
      Name: '',
      Description: 'Pick numbers, win instant prizes.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/keno.png',
      Route: 'Keno',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/keno.png',
      lookup: 'kino',
    },
    {
      Name: '',
      Description: 'Avoid bombs for massive multipliers.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/mines.png',
      Route: 'Mines',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/mines.png',
      lookup: 'Mines',
    },
    {
      Name: '',
      Description: 'Drop the ball, win big.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/plinko.png',
      Route: 'Plinko',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/plinko.png',
      lookup: 'Plinko',
    },
    {
      Name: '',
      Description: 'Spin the wheel of fortune.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/roulet.png',
      Route: 'Roulette',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/roulet.png',
      lookup: 'roulette',
    },
    {
      Name: '',
      Description: 'Scratch and reveal instant wealth.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/scrach.png',
      Route: 'SectrechCards',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/scrach.png',
      lookup: 'scratch',
    },
    {
      Name: '',
      Description: 'One spin can change everything.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/spin.png',
      Route: 'spinner',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/spin.png',
      lookup: 'spinner',
    },
    // {
    //   Name: "",
    //   Description: "Stack higher to win more.",
    //   ImageUrl: "https://cmaxbanners.pages.dev/assets/stack.png",
    //   Route: "StackBuilder",
    //   ImageBase64: "https://cmaxbanners.pages.dev/assets/stack.png",
    //    lookup: "Treasure"
    // },
    {
      Name: '',
      Description: 'Fast-paced action, legendary rewards.',
      ImageUrl: 'https://cmaxbanners.pages.dev/assets/traseur.png',
      Route: 'TreasurePick',
      ImageBase64: 'https://cmaxbanners.pages.dev/assets/traseur.png',
      lookup: 'Treasure',
    },
  ];

  isMobileScreen: boolean = false;

  getTestimonials() {
    const payload = null;
    const apiRoute = 'Public/GetTestImonialsApp';

    this._apiCall
      .PostCallWithToken(payload, apiRoute)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            // console.log('Testimonials Data:', response.data);
            this.testimonialsImages.push(...response.data);
            //? add isLoading attribute
            this.testimonialsImages.forEach((testimonial) => {
              testimonial.isLoading = true;
            });
          } else {
            this.ErroHandling.handleResponseError(response);
          }
        },
        (error) => {
          this.ErroHandling.handleHttpError(error);
        },
      );
  }
  gameOffers: any;

  HotLottery: any;
  HotSctrach: any;
  HotSpinner: any;

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: [
      '<span class="sr-only">Previous</span>',
      '<span class="sr-only">Next</span>',
    ],
    margin: 0,
    stagePadding: 0,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        margin: 0,
      },
      480: {
        items: 1,
        stagePadding: 0,
        margin: 0,
      },
      640: {
        items: 1,
        stagePadding: 0,
        margin: 0,
      },
      768: {
        items: 1,
        stagePadding: 0,
        margin: 0,
      },
      1024: {
        items: 1,
        stagePadding: 0,
        margin: 0,
      },
    },
    nav: false,
  };
  textName: string = '';

  /**
   * Navigate to a route and scroll to top with smooth animation when navigation completes.
   */
  private navigateAndScroll(path: string) {
    // `navigate` returns a Promise<boolean> that resolves when navigation succeeds/fails
    this.router
      .navigate([path])
      .then((navigated) => {
        if (navigated) {
          this.scrollToTopSmooth();
        }
      })
      .catch(() => {
        // On error, still attempt to scroll to top as a fallback
        this.scrollToTopSmooth();
      });
  }

  /** Smooth scroll to top with graceful fallback. */
  private scrollToTopSmooth(): void {
    try {
      // Use smooth scrolling when supported
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      // Fallback for older browsers/environments
      try {
        window.scrollTo(0, 0);
      } catch {
        // ignore
      }
    }
  }

  isdownloadApps: boolean = false;

  onPlayNow(name: any) {
    // 2. Retrieve and parse data from LocalStorage
    const storedGames = JSON.parse(localStorage.getItem('bis_offer') || '[]');
    // 3. Find the specific game in the stored array
    // Ensure the name in quickGames matches the GameName in your local storage
    const gameStatus = storedGames.find((g: any) => g.GameName === name.lookup);
    // 4. Check if game is on update
    if (gameStatus && gameStatus.IsOnUpdate === 'True') {
      // Show error (e.g., Alert, Snackbar, or Toast)
      this.toastr.warning(
        'warning',
        'Game is under update!. Please try again later.',
      );
      return;
    }

    const targetRoute = name.Route || '';

    if (targetRoute !== '') {
      this.navigateAndScroll(`/dashboard/${targetRoute}`);
    } else {
      console.warn('[openModule] Unknown module key:', targetRoute);
    }
  }

  getTestimonialsImages = [];


  ///////////Refrel bonus

  showRefralModal: boolean = false;
  buttonText = "COPY LINK";
  private readonly baseUrl = "https://highrollers.game/SignUp?refral=";
  get referralLink(): string {
    const code = localStorage.getItem('code') || '';
    return `${this.baseUrl}${encodeURIComponent(code)}`;
  }
  copyToClipboard() {
    navigator.clipboard.writeText(this.referralLink).then(() => {
      this.buttonText = "COPIED!";
      setTimeout(() => this.buttonText = "COPY LINK", 2000);
    });
  }

  closeReferal() {
    this.showRefralModal = false;
  }
  openrefral() {
    this.showRefralModal = true;
    // this.getReferalbonus();
  }
  refPercentage: any
  refCount: any
  getReferalbonus() {
    this._apiCall
      .GetCallWithoutToken('User/Getreferralbonus')
      .subscribe({
        next: (response) => {
          if (response.responseCode === 200 && response.data) {
            const data = response.data;
            // Safely find the specific objects based on PaymentName
            const percentageObj = data.find((item: any) => item.PaymentName === 'referralpercentage');
            const countObj = data.find((item: any) => item.PaymentName === 'referralcount');
            // Assign the values if found, otherwise default to 0
            this.refPercentage = percentageObj ? percentageObj.Bonus : '';
            this.refCount = countObj ? countObj.Bonus : '';
          }
        },
        error: (error) => {
          this.ErroHandling.handleHttpError(error);
        },
      });
  }

  // Add this variable to your class
  isBannerVisible = true;

  // Add this function
  closeBanner(event: Event) {
    // This prevents the click from bubbling up to the button underneath
    event.stopPropagation();
    this.isBannerVisible = false;
  }

  gotoreflist() {
    this.showRefralModal = false;
    this.router.navigate(['dashboard/referallist']);
  }
}
